import {clsx} from 'clsx'

import {HeaderAppearanceSettings} from '../AppearanceSettings/HeaderAppearanceSettings'
import {dashboardAnalyticsEvent, signInAnalyticsEvent} from '../header-analytics'

import type {AuthHydroClickAttributes} from '../../marketing-header.types'
import {AuthCTALink} from './AuthCTALink'
import styles from './AuthCTAs.module.css'

/** Dashboard CTA target, matching the legacy `href="/"`. */
const DASHBOARD_HREF = '/'

type MobileAuthActionsProps = {
  loggedIn: boolean
  marketingPage: boolean
  loginPath: string
  hydro: AuthHydroClickAttributes

  /** While the mobile menu is open, drop these CTAs from the trapped tab order (legacy parity). */
  isMenuOpen: boolean
}

/**
 * Mobile-only (`< lg`) top-row auth CTAs: a single Sign in (logged out) or Dashboard (logged in), plus
 * the appearance-settings trigger on logged-out, non-marketing pages. Desktop equivalents live in
 * {@link DesktopAuthActions} inside the expanding menu.
 */
export function MobileAuthActions({loggedIn, marketingPage, loginPath, hydro, isMenuOpen}: MobileAuthActionsProps) {
  const tabIndex = isMenuOpen ? -1 : undefined

  return (
    <div className={styles.mobileActions}>
      {loggedIn ? (
        <AuthCTALink
          href={DASHBOARD_HREF}
          className={clsx(styles.link, styles.button, styles.mutedOutline)}
          analyticsEvent={dashboardAnalyticsEvent}
          hydro={hydro}
          tabIndex={tabIndex}
        >
          Dashboard
        </AuthCTALink>
      ) : (
        <>
          <AuthCTALink
            href={loginPath}
            className={clsx(styles.link, styles.button, styles.defaultOutline)}
            analyticsEvent={signInAnalyticsEvent}
            hydro={hydro}
            tabIndex={tabIndex}
          >
            Sign in
          </AuthCTALink>

          {!marketingPage ? <HeaderAppearanceSettings /> : null}
        </>
      )}
    </div>
  )
}
